export const webConfig = {
  appBundleBaseName: 'atoz-hvhcareersite',
  appManifestName: 'atozHVHCareerSiteManifest',
  packagingDirName: 'packaging_additional_published_artifacts',
  widgetName: 'atoz-hvhcareersite',
};
